import React, { useEffect} from "react";
import CategoriaComponent from "../components/Categoria/index";
import SliderImages from "../components/SlideImages";
import {useDispatch,useSelector} from 'react-redux';
import {FetchCategoria} from '../Actions/categoriaAction';

export default function Home() {
    const dispatch = useDispatch();
    const{Loading,Categoria} = useSelector(state => state.categoria);

    useEffect(() => {
        dispatch(FetchCategoria());
    }, []);

    return (
        <>
            <SliderImages></SliderImages>
            <CategoriaComponent loading={Loading} categoria={Categoria} />
        </>
    );
}
